import React, { useState } from 'react';
import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';
import { colors, textBold } from 'styles';
import { breakpoint } from 'utils/mediaQueries';
import { Grid, Typography } from '@material-ui/core';
import IconBlock from 'components/basics/Icons';
import { CompanyInformations } from 'config/companyInformations';

const Title = styled(Markdown)`
  font-family: ${props => `${props.theme.typography.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.h6.fontSize}px`};
  line-height: 2rem;
  color: ${colors.red};
  ${textBold}
  ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};`}
`;
const NumberTel = styled(Title)`
  color: ${colors.black};
  margin-left: 0.5rem;
  ${breakpoint.down('sm')`
font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`}`}
`;
const Telephone = styled(Grid)`
  padding-top: 0.5rem;
  ${breakpoint.down('md')`
  justify-content: center;font-size: ${props =>
    `${props.theme.typography.body1.fontSize}px`}`}
`;
const Text = styled(Typography)`
  display: flex;
  flex-direction: column;
  font-family: ${props => `${props.theme.typography.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};
  line-height: 2rem;
  ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.body2.fontSize}px`};`};
`;
const ContactImage = styled(Grid)`
  width: auto;
  padding: 0.4rem;
  border-radius: 50%;
  background-color: ${colors.black};
  path {
    fill: ${props => colors[props.coloricon]};
  }
  img {
    max-width: 2.5rem;
    ${breakpoint.down('lg')`
    max-width: 2.3rem`}
    ${breakpoint.down('md')`
    max-width: 2rem`}
  }
`;
const StyledLink = styled.a`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const TextContactUs = ({ data }) => {
  return (
    <Grid>
      <Title>{data.frontmatter.title}</Title>
      <Telephone container direction={'row'} alignItems="flex-end">
        <StyledLink href={'tel:' + CompanyInformations.telLink}>
          <ContactImage container alignItems="center" coloricon={'white'}>
            <IconBlock icon={'phone'} heightIcon={20} widthIcon={20} />
          </ContactImage>
          <NumberTel>{CompanyInformations.telephone}</NumberTel>
        </StyledLink>
      </Telephone>
      <Text>
        {CompanyInformations.mail}
        <br />
        {CompanyInformations.mailJob}
      </Text>
    </Grid>
  );
};
export default TextContactUs;
